module.exports = __webpack_public_path__ + "media/images/emails/existing_org_new_user_message/enable-nicklpass-60183469b1f9e3a5515cbac49e5135c8.png";